import React from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getUsersRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {OrgDashboardFilters} from "root/DataFunctions/Constants";

const UsersDashboardSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const org_dashboard_filter = queryParams.type === undefined ? OrgDashboardFilters.CHILD_AGE : queryParams.type;

    return (
        <AppSidebarGroup title='Dashboard' default={org_dashboard_filter}>
            <AppSidebarMenuItem link={getUsersRouterLink('dashboard?type=child-age')} title='Child Age' name={OrgDashboardFilters.CHILD_AGE} iconName='icon-user-o'/>
            <AppSidebarMenuItem link={getUsersRouterLink('dashboard?type=users')} title='Users by Type' name={OrgDashboardFilters.USERS} iconName='icon-family'/>
        </AppSidebarGroup>
    )
}

export default UsersDashboardSubmenu ;